import Cookies from "js-cookie";

const AccessTokenKey = "user_access_token";
const Account = "user_account";
const Language = "user_language";

export function getAccessToken() {
  return Cookies.get(AccessTokenKey);
}

export function setAccessToken(token) {
  return Cookies.set(AccessTokenKey, token);
}

export function removeAccessToken() {
  return Cookies.remove(AccessTokenKey);
}

export function getAccount() {
  return Cookies.get(Account);
}

export function setAccount(token) {
  return Cookies.set(Account, token);
}

export function removeAccount() {
  return Cookies.remove(Account);
}

export function getLanguage() {
  return Cookies.get(Language);
}

export function setLanguage(language) {
  return Cookies.set(Language, language);
}

export function removeLanguage() {
  return Cookies.remove(Language);
}
